module.exports = __webpack_public_path__ + "img/vertical_6_3_9005.9360e899.png";